export default __webpack_public_path__ + "static/media/background.bbd0c564.png";